import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../images/footerlogo.png";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { products, companyInfo } from "../data/companyData";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content">
        <div className="left">
          <div className="logoSection">
            <img className="image" src={logo} alt="Quinterra logo" />
          </div>

          <h4 className="heading-8">{companyInfo.legalName}</h4>

          <div className="contactSection">
            <div className="infodiv">
              <div className="text-block-icon">
                <PhoneIcon fontSize="large" />
              </div>
              <div className="text-block-3">
                <span className="text-span">Phone</span>
                <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} className="text-span1 footer-link">
                  {companyInfo.phone}
                </a>
              </div>
            </div>

            <div className="infodiv">
              <div className="text-block-icon">
                <EmailIcon fontSize="large" />
              </div>
              <div className="text-block-3">
                <span className="text-span">Email</span>
                <a href={`mailto:${companyInfo.email}`} className="text-span1 footer-link">
                  {companyInfo.email}
                </a>
              </div>
            </div>

            <div className="infodiv">
              <div className="text-block-icon">
                <LocationOnIcon fontSize="large" />
              </div>
              <div className="text-block-3">
                <span className="text-span">Address</span>
                <span className="text-span1">{companyInfo.address}</span>
              </div>
            </div>

            <div className="infodiv">
              <div className="text-block-icon">
                <LinkedInIcon fontSize="large" />
              </div>
              <div className="text-block-3">
                <span className="text-span">LinkedIn</span>
                <a
                  href={companyInfo.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="text-span1 footer-link"
                  aria-label="Quinterra on LinkedIn"
                >
                  Quinterra Software Solutions
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="linksSection">
          <div className="linksWrapper">
            <div className="linksCol">
              <h3 className="home-c">Products</h3>
              <div className="linksGrid">
                {products.map((product) =>
                  product.url ? (
                    <a
                      key={product.id}
                      href={product.url}
                      target="_blank"
                      rel="noreferrer"
                      className="home-a"
                    >
                      {product.name}
                    </a>
                  ) : (
                    <span key={product.id} className="home-a footer-coming-soon">
                      {product.name} (Coming Soon)
                    </span>
                  )
                )}
              </div>
            </div>

            <div className="linksCol">
              <h3 className="home-c">Company</h3>
              <div className="linksGrid">
                <Link to="/about" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  About
                </Link>
                <Link to="/contact" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Contact
                </Link>
                <Link to="/privacy-policy" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Privacy Policy
                </Link>
                <Link to="/terms-of-service" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Terms
                </Link>
              </div>
            </div>

            <div className="linksCol">
              <h3 className="home-c">Quick Links</h3>
              <div className="linksGrid">
                <Link to="/" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Home
                </Link>
                <Link to="/products" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Products
                </Link>
                <Link to="/technologies" className="home-a" onClick={() => window.scrollTo(0, 0)}>
                  Technologies
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom">
        <p className="home-b">
          © 2026 Quinterra Software Solutions Pvt. Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
